import {
  RetailerNetworkLocationGroupFilter,
  RetailerNetworkLocationGroupFragment,
} from '@occc/graphql';

import { useGetRetailerNetworkLocationGroupsLazy } from '../../data-access/queries';

export const makeRetailerNetworkLocationGroupFilter =
  (retailerNetworkUuid: string) =>
  (search?: string): RetailerNetworkLocationGroupFilter => ({
    retailerNetworkUuidEquals: retailerNetworkUuid,
    search: search || undefined,
  });

export const mapQueryResponseToRawArray = (
  response: ReturnType<typeof useGetRetailerNetworkLocationGroupsLazy>['response'],
) => response.data || [];

export const mapRawResponseItemToAutocompleteOption = (
  locationGroup: RetailerNetworkLocationGroupFragment,
) => ({
  value: locationGroup.uuid,
  label: locationGroup.name,
  _raw: locationGroup,
});
